module.exports = __webpack_public_path__ + "media/newstyle/images/icon-lp-2-orange-00e83e99060692c9b43c60e9323e22cf.svg";